import { HelpStoreProvider } from "./store/help_store";
import { HelpContainer } from "./help";
export function Help() {
  return (
    <HelpStoreProvider>
      <HelpContainer />
    </HelpStoreProvider>
  );
}
